import React, { useEffect } from 'react';

import { Bell, Megaphone, Send } from 'lucide-react';

import publicConfig from 'common/core/publicConfig';
import { isMobile } from 'common/hooks/useMedia';
import NotificationsMenu from 'common/notifications/NotificationsMenu';
import { cn } from 'common/style/utils';
import AdminAutopilotImportPopover from 'common/subdomain/admin/AdminAutopilotImportPopover';
import styles from 'css-module/components/subdomain/admin/v2/_AdminV2Nav.module.scss';

import AdminNavAccountMenu from './AdminNavAccountMenu';
import AdminV2NavDesktopMenu from './AdminV2NavDesktopMenu';
import AdminV2NavIconButton from './AdminV2NavIconButton';
import AdminV2NavMobileMenu from './AdminV2NavMobileMenu';

function AdminV2Nav() {
  useEffect(() => {
    window.Canny('initChangelog', {
      appID: publicConfig('cannyCompanyID'),
      position: isMobile() ? 'bottom' : 'right',
      align: isMobile() ? 'left' : 'bottom',
    });
  }, []);

  return (
    <nav className={cn(styles.nav, 'bg-sidebar')}>
      <AdminV2NavMobileMenu />
      <AdminV2NavDesktopMenu />
      <ul className={styles.navSection}>
        <li>
          <AdminAutopilotImportPopover
            side="right"
            align="end"
            sideOffset={12}
            trigger={<AdminV2NavIconButton Icon={Send} label="Send to Autopilot" />}
          />
        </li>
        <li className={styles.changelogOption}>
          <AdminV2NavIconButton Icon={Megaphone} data-canny-changelog label="Announcements" />
        </li>
        <li>
          <NotificationsMenu
            linkToAdmin={true}
            position={isMobile() ? 'bottom' : 'right'}
            showTooltip={false}
            button={({ onClick }: { onClick: () => void }) => (
              <AdminV2NavIconButton Icon={Bell} label="Notifications" onClick={onClick} />
            )}
          />
        </li>
        <li className={styles.accountOption}>
          <AdminNavAccountMenu />
        </li>
      </ul>
    </nav>
  );
}

export default AdminV2Nav;
